import { theme } from "../../styles/theme/theme"
import type { RowStatus } from "./types"

// ─── Frozen column widths (px) ──────────────────────────────────────────────

export const RETAILER_COL_W = 350
export const STATUS_COL_W = 32
export const CHECKBOX_COL_W = 32
export const SKU_COL_W = 120
// Position-4 col width (shared): holds "Marked Ready" date in the top table,
// the SKU code in the bottom main row, and the measure label in the detail row.
export const MARKED_READY_COL_W = 180
export const CELL_MIN_W = 68

// ─── Status workflow ────────────────────────────────────────────────────────

export const STATUS_ORDER: RowStatus[] = ["baseline", "edited", "ready"]

export const STATUS_CONFIG: Record<RowStatus, { color: string; label: string }> = {
  baseline: { color: theme.colors.gray400, label: "Baseline" },
  edited: { color: theme.colors.blue500, label: "Edited" },
  ready: { color: theme.colors.itemStatus.sent, label: "Ready" },
}

// ─── Measure configuration ──────────────────────────────────────────────────
// All supply-walk measure config — keys (incl. forecast_shipments_delta),
// labels, sign/color, formatting, and WOS shading — lives in the shared module
// (src/lib/supplyWalkMeasures.ts) and is re-exported here so RetailerSupplyView's
// own files can keep importing from "./constants".
export {
  MEASURE_KEYS,
  MEASURE_SIGN,
  SIGN_COLOR,
  ACTUALS_MEASURE_KEYS,
  FALLBACK_SUPPRESSED_KEYS,
  getMeasureLabel,
  wosCellBg,
  wosCellColor,
} from "../../lib/supplyWalkMeasures"
